/*
 * Layout Name: How Hopp Works
 *
 * Desc:
 */
import ReactMarkdown from "react-markdown"
import Slider from "react-slick"
//components
import Section from "../../../structure/Section/Section"
import styles from "./HowSupplierWorks.module.scss"
import useMediaQuery from "@lib/useMediaQuery"

const HowSupplierWorks = (props) => {
  //Resize controll
  const isMobile = useMediaQuery(1099)

  const features = props.features.map((feature, i) => {
    return (
      <div key={i}>
        <div className={styles.feature}>
          <img src={feature.image} alt="" />
          <div className={styles.text}>
            <span>{i + 1}</span>
            <h3>{feature.title}</h3>
            <ReactMarkdown>{feature.text}</ReactMarkdown>
          </div>
        </div>
      </div>
    )
  })

  const sliderSettings = {
    arrows: false,
    // dots: true,
    adaptiveHeight: true,
    slidesToShow: 1,
    centerMode: true,
  }

  return (
    <Section className={styles.HowSupplierWorks}>
      <h2>{props.title}</h2>
      <div className={styles.grid}>{isMobile ? <Slider {...sliderSettings}>{features}</Slider> : features}</div>
    </Section>
  )
}

export default HowSupplierWorks
